import { type MouseEvent, useCallback, useState } from "react";

export const useChartActions = () => {
  const [isShareOpen, setIsShareOpen] = useState(false);
  const [citeAnchor, setCiteAnchor] = useState<HTMLElement | null>(null);

  const handleShareOnX = useCallback(() => {
    setIsShareOpen(true);
  }, []);

  const handleShareClose = useCallback(() => {
    setIsShareOpen(false);
  }, []);

  const handleCite = useCallback((event: MouseEvent<HTMLElement>) => {
    setCiteAnchor(event.currentTarget);
  }, []);

  const handleCiteClose = useCallback(() => {
    setCiteAnchor(null);
  }, []);

  return {
    isShareOpen,
    citeAnchor,
    handleShareOnX,
    handleShareClose,
    handleCite,
    handleCiteClose,
  };
};
